import { Fragment, useState } from "react";
import API from '../../../config/API';
import {useNavigate} from 'react-router-dom';

const AddMaterialOntology = () => {
  const [state, setState] = useState({disabled:true, name:"", R:"", G:"", B:"", nirReflectance: "", nirOpacity: ""});
  const nav = useNavigate();

  const createOntology = () =>{

    if(validOntology()){
      setState({...state, disabled:true});
      API.post('/v3/api/materialOntology/', {
        name: state.name,
        r: parseInt(state.R),
        g: parseInt(state.G),
        b: parseInt(state.B),
        nirReflectance: state.nirReflectance != "" ? parseFloat(state.nirReflectance) : null,
        nirOpacity: state.nirOpacity != "" ? parseFloat(state.nirOpacity) : null,
      }).then( (e)=>{

        if(typeof e !== 'string'){
          nav('/app/materialontology');
        }else{
          setState({...state, disabled:false, alert:"danger", message: e});
        }

      } )

    }

  }

  const validOntology = () => {
    return ( state.name.length >= 1 && validRGB() && validNIR() ? true : false );
  }

  const validRGB = () =>{
    const R = parseInt(state.R);
    const G = parseInt(state.G);
    const B = parseInt(state.B);

    return (R <= 255 && G <= 255 && B <= 255);
  }

  const validNIR = () =>{
    return state.nirReflectance !== "" ? !Number.isNaN( parseFloat( state.nirReflectance ) ) : true &&
           state.nirOpacity !== "" ? !Number.isNaN( parseFloat( state.nirOpacity ) ) : true;
  }

  return(
    <Fragment>
      <h2>Add material ontology registry</h2>
      {state?.alert && <div className={"alert alert-"+state.alert+" mt-5"}>{state.message}</div>}
      <br />
      <div className="row">
        <div className="col-md-6">
          <h4>Name:</h4>
          <input type="text" id="name" className="form-control" onChange={(e)=>{setState({...state, name: e.target.value})}}/>

          <h4 className="mt-5">Color:</h4>
          <div className="row">
            <div className="col-md-4"><input type="number" className="form-control" placeholder={"R"} onChange={(e)=>{setState({...state, R: e.target.value})}}/></div>
            <div className="col-md-4"><input type="number" className="form-control" placeholder={"G"} onChange={(e)=>{setState({...state, G: e.target.value})}}/></div>
            <div className="col-md-4"><input type="number" className="form-control" placeholder={"B"} onChange={(e)=>{setState({...state, B: e.target.value})}}/></div>
            <div className="col-md-4"><input type="string" className="form-control" placeholder={"Reflectance"} onChange={(e)=>{setState({...state, nirReflectance: e.target.value})}}/></div>
            <div className="col-md-4"><input type="string" className="form-control" placeholder={"Opacity"} onChange={(e)=>{setState({...state, nirOpacity: e.target.value})}}/></div>
          </div>
          {(validRGB()?<div className="mt-2 border border-white" style={{background:"rgb("+state.R+","+state.G+","+state.B+")", color:"rgb("+state.R+","+state.G+","+state.B+")"}}>█</div>:"")}

          <button className="btn btn-success mt-5" onClick={createOntology} disabled={(!validOntology())}>Create material ontology registry</button>
        </div>


      </div>
    </Fragment>
  )
};

export default AddMaterialOntology;